module.exports = __webpack_public_path__ + "fonts/ConfigCondensed-LightItalic.97e97f11.otf";